import { agencyApis } from '@apis/dashboard/agencyApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useAgencyList = createUseQuery(
  ['/dashboard/agency/'],
  () => () => agencyApis.get('/dashboard/agency/', {}).then((r) => r[200]!),
);
